import React from 'react'

import { Title } from '../../../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import Panel, { PanelContent } from '../../../../../components/structure/Panel'
import Separator from '../../../../../components/helpers/Separator'
import { COLORS } from '@btime/constants'
import Markdown from '../../../../../components/presentation/Markdown'
import { useDynamicServiceOrders } from '../../_load/DynamicServiceOrdersLoader'

const DynamicServiceOrderDetailsPanel = () => {
  const { name, description } = useDynamicServiceOrders()

  return (
    <Panel lineBorder noPadding>
      <PanelContent mediumPadding>
        <FlexGrid align="flex-start" wrap>
          <FlexCol flex={1}>
            <Separator weight={3} />
            <Title size="h2">{name}</Title>
          </FlexCol>
        </FlexGrid>
        <FlexGrid align="flex-start" wrap>
          <FlexCol flex={1}>
            <Markdown color={COLORS.dark3}>{description}</Markdown>
          </FlexCol>
        </FlexGrid>
      </PanelContent>
    </Panel>
  )
}

export default DynamicServiceOrderDetailsPanel
